<!-- ======= Exam Nav (New) (Start) ======= -->
@if (newSidebar) {
  <app-es-patient-card [pat]="pat" [warningMsg]="ntWarning">
    <button
      card-add-btn
      class="es-patient-card__add-btn"
      [class.es-patient-card__add-btn--warning]="showBirthWarning"
      [matTooltip]="'GUI.Tooltips.Open Patient Details' | translate | titlecase"
      (click)="showPatD()"
    >
      <mat-icon class="es-patient-card__add-icon">add</mat-icon>
    </button>
    <ng-container card-btn-strip>
      <button
        class="es-patient-card__btn"
        [class.es-patient-card__btn--active]="isBookmark"
        [matTooltip]="'GUI.Tooltips.Show Previous Exams in a Window' | translate | titlecase"
        (click)="bookmark()"
      >
        <mat-icon class="es-patient-card__btn-icon">bookmarks</mat-icon>
      </button>
      <button
        class="es-patient-card__btn"
        [matTooltip]="'GUI.Tooltips.Close Exam and Open Patient History' | translate | titlecase"
        (click)="go('/exams')"
      >
        <mat-icon class="es-patient-card__btn-icon">logout</mat-icon>
      </button>
    </ng-container>
  </app-es-patient-card>

  @if (surrogate) {
    <div class="es-surrogate">{{ surrogate }}</div>
  }

  <div class="es-tabs">
    @if (showObstetricTabs) {
      @if (es.ExamType === 'Pediatric Echo') {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Anamnesis'"
          role="button"
          tabindex="0"
          data-page="Anamnesis"
          (click)="setPage('Anamnesis')"
          (keyup.enter)="setPage('Anamnesis')"
          (keyup.space)="setPage('Anamnesis')"
          >Anamnesis</a
        >
      }
      @if (pat.ID !== 'default' && es.ExamType !== 'Pediatric Echo') {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Pregnancy'"
          role="button"
          tabindex="0"
          data-page="Pregnancy"
          (click)="setPage('Pregnancy')"
          (keyup.enter)="setPage('Pregnancy')"
          (keyup.space)="setPage('Pregnancy')"
        >
          @if (es.ExamType === 'Follicles') {
            {{ 'GUI.Tabs.Introduction' | translate | titlecase }}
          } @else {
            {{ 'GUI.Tabs.Pregnancy' | translate | titlecase }}
          }
        </a>
      }
      @if (
        es.ExamType !== 'Fetal Echo' &&
        es.ExamType !== 'Pediatric Echo' &&
        es.ExamType !== 'Follicles'
      ) {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Placenta'"
          role="button"
          tabindex="0"
          data-page="Placenta"
          (click)="setPage('Placenta')"
          (keyup.enter)="setPage('Placenta')"
          (keyup.space)="setPage('Placenta')"
        >
          {{ 'GUI.Tabs.Placenta' | translate | titlecase }}
        </a>
      }
      @if (es.ExamType === 'NT' || es.ExamType === '1st' || es.addNT) {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'NT'"
          role="button"
          tabindex="0"
          data-page="NT"
          (click)="setPage('NT')"
          (keyup.enter)="setPage('NT')"
          (keyup.space)="setPage('NT')"
        >
          {{ ntTabLabel }}
        </a>
      }
      @if (es.ExamType !== 'NT' && es.ExamType !== '1st' && es.ExamType !== 'Follicles') {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Measurements'"
          role="button"
          tabindex="0"
          data-page="Measurements"
          (click)="setPage('Measurements')"
          (keyup.enter)="setPage('Measurements')"
          (keyup.space)="setPage('Measurements')"
        >
          {{ measurementsTabKey | translate | titlecase }}
        </a>
      }
      @if (showAnatomyTab) {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Anatomy'"
          role="button"
          tabindex="0"
          data-page="Anatomy"
          (click)="setPage('Anatomy')"
          (keyup.enter)="setPage('Anatomy')"
          (keyup.space)="setPage('Anatomy')"
          >{{ 'GUI.Tabs.Anatomy' | translate | titlecase }}</a
        >
      }
      @if (showObsDopplerTab) {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'Obs Doppler'"
          role="button"
          tabindex="0"
          data-page="Obs Doppler"
          (click)="setPage('Obs Doppler')"
          (keyup.enter)="setPage('Obs Doppler')"
          (keyup.space)="setPage('Obs Doppler')"
          >{{ 'GUI.Tabs.Obs Doppler' | translate | titlecase }}</a
        >
      }
    }

    @if (es.ExamType === 'Gynecology') {
      <a
        class="es-tabs__item"
        [class.es-tabs__item--active]="currentPage === 'Introduction'"
        role="button"
        tabindex="0"
        data-page="Introduction"
        (click)="setPage('Introduction')"
        (keyup.enter)="setPage('Introduction')"
        (keyup.space)="setPage('Introduction')"
        >{{ 'GUI.Tabs.Introduction' | translate | titlecase }}</a
      >
    }

    @if (es.ExamType === 'Gynecology' || es.switchOvaries) {
      <a
        class="es-tabs__item"
        [class.es-tabs__item--active]="currentPage === 'Uterus'"
        role="button"
        tabindex="0"
        data-page="Uterus"
        (click)="setPage('Uterus')"
        (keyup.enter)="setPage('Uterus')"
        (keyup.space)="setPage('Uterus')"
        >{{ 'GUI.Tabs.Uterus' | translate | titlecase }}</a
      >
      <a
        class="es-tabs__item"
        [class.es-tabs__item--active]="currentPage === 'Ovaries'"
        role="button"
        tabindex="0"
        data-page="Ovaries"
        (click)="setPage('Ovaries')"
        (keyup.enter)="setPage('Ovaries')"
        (keyup.space)="setPage('Ovaries')"
        >{{ 'GUI.Tabs.Ovaries & Fallopian Tubes' | translate }}</a
      >
      @if (es.ExamType === 'Gynecology') {
        <a
          class="es-tabs__item"
          [class.es-tabs__item--active]="currentPage === 'doppler'"
          role="button"
          tabindex="0"
          data-page="doppler"
          (click)="setPage('doppler')"
          (keyup.enter)="setPage('doppler')"
          (keyup.space)="setPage('doppler')"
          >Doppler</a
        >
      }
    }

    @if (es.ExamType === 'Amniocentesis' || es.ExamType === 'CVS' || es.ExamType === 'Follicles') {
      <a
        class="es-tabs__item"
        [class.es-tabs__item--active]="currentPage === 'Procedure'"
        role="button"
        tabindex="0"
        data-page="Procedure"
        (click)="setPage('Procedure')"
        (keyup.enter)="setPage('Procedure')"
        (keyup.space)="setPage('Procedure')"
      >
        Course of Exam
      </a>
    }

    @if (showSummaryTab) {
      <a
        class="es-tabs__item"
        [class.es-tabs__item--active]="currentPage === 'Summary'"
        role="button"
        tabindex="0"
        data-page="Summary"
        (click)="setPage('Summary')"
        (keyup.enter)="setPage('Summary')"
        (keyup.space)="setPage('Summary')"
      >
        @if (es.ExamType === 'Duplex Carotid') {
          Findings and Diagnosis
        } @else {
          {{ 'GUI.Tabs.Summary' | translate | titlecase }}
        }
      </a>
    }
  </div>
}
<!-- ======= Exam Nav (New) (End) ======= -->

<!-- ======= Exam Nav (Legacy) (Start) ======= -->
@if (!newSidebar) {
  <div class="userPanel">
    @if (pat.ID != 'default') {
      <i class="userPanel-icon icon-female">
        <span class="l-flex t-boxMargin menstural-fields-set">
          <button
            class="btn-user_data"
            aria-label="user data"
            [class.is-invalid]="showBirthWarning"
            [matTooltip]="'GUI.Tooltips.Open Patient Details' | translate | titlecase"
            (click)="showPatD()"
          ></button>
          @if (es.ExamType === 'NT') {
            <div class="t-validation-message">
              <span>
                {{ 'GUI.NT.CustomTooltips.Add Birth day by clicking here' | translate | titlecase }}
              </span>
            </div>
          }
        </span>
      </i>

      <div class="userPanel-userName">{{ pat.First }} {{ pat.Last }}</div>

      <dl class="l-table userPanel-userInfo">
        <div class="l-row">
          <dt class="l-td-m">
            {{ 'GUI.General.ID Number' | translate | titlecase }}
          </dt>
          <dd class="l-td-m">{{ pat.ID }}</dd>
        </div>
        <div class="l-row">
          <dt class="l-td-m">
            {{ 'GUI.General.Age' | translate | titlecase }}
          </dt>
          <dd class="l-td-m">{{ patservice.getAgeMo() }}</dd>
        </div>
        @if (es.ExamType != 'Gynecology' && es.ExamType != 'Follicles') {
          <div class="l-row">
            <dt class="l-td-m">
              {{ 'GUI.General.GA (at exam)' | translate }}
            </dt>
            <dd class="l-td-m">{{ es.examGA() }}</dd>
          </div>
        }
        @if (surrogate) {
          <div class="l-row">
            <dt class="l-td-m">Surrogate</dt>
            <dd class="l-td-m">{{ surrogate }}</dd>
          </div>
        }
      </dl>
    }

    <div class="userPanel-controls">
      <a
        class="userPanel-controls-item icon-files"
        [class.saved]="isBookmark"
        role="button"
        tabindex="0"
        aria-label="files"
        [matTooltip]="'GUI.Tooltips.Show Previous Exams in a Window' | translate | titlecase"
        (click)="bookmark()"
        (keyup.enter)="bookmark()"
        (keyup.space)="bookmark()"
      ></a>
      <a
        class="userPanel-controls-item icon-exit"
        role="button"
        tabindex="0"
        aria-label="exit"
        [matTooltip]="'GUI.Tooltips.Close Exam and Open Patient History' | translate | titlecase"
        (click)="go('/exams')"
        (keyup.enter)="go('/exams')"
        (keyup.space)="go('/exams')"
      ></a>
    </div>
  </div>

  <nav class="mainNav l-fg1">
    <ul class="mainNav-list">
      @if (showObstetricTabs) {
        @if (es.ExamType === 'Pediatric Echo') {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Anamnesis"
            (click)="setPage('Anamnesis')"
            (keyup.enter)="setPage('Anamnesis')"
            (keyup.space)="setPage('Anamnesis')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Anamnesis'">
              Anamnesis
            </span>
          </li>
        }
        @if (pat.ID != 'default' && es.ExamType !== 'Pediatric Echo') {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Pregnancy"
            (click)="setPage('Pregnancy')"
            (keyup.enter)="setPage('Pregnancy')"
            (keyup.space)="setPage('Pregnancy')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Pregnancy'">
              @if (es.ExamType == 'Follicles') {
                {{ 'GUI.Tabs.Introduction' | translate | titlecase }}
              } @else {
                {{ 'GUI.Tabs.Pregnancy' | translate | titlecase }}
              }
            </span>
          </li>
        }
        @if (
          es.ExamType != 'Fetal Echo' &&
          es.ExamType !== 'Pediatric Echo' &&
          es.ExamType != 'Follicles'
        ) {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Placenta"
            (click)="setPage('Placenta')"
            (keyup.enter)="setPage('Placenta')"
            (keyup.space)="setPage('Placenta')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Placenta'">
              {{ 'GUI.Tabs.Placenta' | translate | titlecase }}
            </span>
          </li>
        }
        @if (es.ExamType == 'NT' || es.ExamType == '1st' || es.addNT) {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="NT"
            (click)="setPage('NT')"
            (keyup.enter)="setPage('NT')"
            (keyup.space)="setPage('NT')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'NT'">
              {{ ntTabLabel }}
            </span>
          </li>
        }
        @if (es.ExamType != 'NT' && es.ExamType != '1st' && es.ExamType != 'Follicles') {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Measurements"
            (click)="setPage('Measurements')"
            (keyup.enter)="setPage('Measurements')"
            (keyup.space)="setPage('Measurements')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Measurements'">
              {{ measurementsTabKey | translate | titlecase }}
            </span>
          </li>
        }
        @if (showAnatomyTab) {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Anatomy"
            (click)="setPage('Anatomy')"
            (keyup.enter)="setPage('Anatomy')"
            (keyup.space)="setPage('Anatomy')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Anatomy'">
              {{ 'GUI.Tabs.Anatomy' | translate | titlecase }}
            </span>
          </li>
        }
        @if (showObsDopplerTab) {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="Obs Doppler"
            (click)="setPage('Obs Doppler')"
            (keyup.enter)="setPage('Obs Doppler')"
            (keyup.space)="setPage('Obs Doppler')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'Obs Doppler'">
              {{ 'GUI.Tabs.Obs Doppler' | translate | titlecase }}
            </span>
          </li>
        }
      }
      @if (es.ExamType == 'Gynecology') {
        <li
          class="mainNav-item"
          role="button"
          tabindex="0"
          data-page="Introduction"
          (click)="setPage('Introduction')"
          (keyup.enter)="setPage('Introduction')"
          (keyup.space)="setPage('Introduction')"
        >
          <span class="mainNav-link" [class.is-active]="currentPage == 'Introduction'">
            {{ 'GUI.Tabs.Introduction' | translate | titlecase }}
          </span>
        </li>
      }
      @if (es.ExamType == 'Gynecology' || es.switchOvaries) {
        <li
          class="mainNav-item"
          role="button"
          tabindex="0"
          data-page="Uterus"
          (click)="setPage('Uterus')"
          (keyup.enter)="setPage('Uterus')"
          (keyup.space)="setPage('Uterus')"
        >
          <span class="mainNav-link" [class.is-active]="currentPage == 'Uterus'">
            {{ 'GUI.Tabs.Uterus' | translate | titlecase }}
          </span>
        </li>
        <li
          class="mainNav-item"
          role="button"
          tabindex="0"
          data-page="Ovaries"
          (click)="setPage('Ovaries')"
          (keyup.enter)="setPage('Ovaries')"
          (keyup.space)="setPage('Ovaries')"
        >
          <span class="mainNav-link" [class.is-active]="currentPage == 'Ovaries'">
            {{ 'GUI.Tabs.Ovaries & Fallopian Tubes' | translate }}
          </span>
        </li>
        @if (es.ExamType === 'Gynecology') {
          <li
            class="mainNav-item"
            role="button"
            tabindex="0"
            data-page="doppler"
            (click)="setPage('doppler')"
            (keyup.enter)="setPage('doppler')"
            (keyup.space)="setPage('doppler')"
          >
            <span class="mainNav-link" [class.is-active]="currentPage == 'doppler'"> Doppler </span>
          </li>
        }
      }

      @if (es.ExamType == 'Amniocentesis' || es.ExamType == 'CVS' || es.ExamType == 'Follicles') {
        <li
          class="mainNav-item"
          role="button"
          tabindex="0"
          data-page="Procedure"
          (click)="setPage('Procedure')"
          (keyup.enter)="setPage('Procedure')"
          (keyup.space)="setPage('Procedure')"
        >
          <span class="mainNav-link" [class.is-active]="currentPage == 'Procedure'">
            Course of Exam
          </span>
        </li>
      }
      @if (showSummaryTab) {
        <li
          class="mainNav-item"
          role="button"
          tabindex="0"
          data-page="Summary"
          (click)="setPage('Summary')"
          (keyup.enter)="setPage('Summary')"
          (keyup.space)="setPage('Summary')"
        >
          <span class="mainNav-link" [class.is-active]="currentPage == 'Summary'">
            @if (es.ExamType == 'Duplex Carotid') {
              Findings and Diagnosis
            } @else {
              {{ 'GUI.Tabs.Summary' | translate | titlecase }}
            }
          </span>
        </li>
      }
    </ul>
  </nav>
}
<!-- ======= Exam Nav (Legacy) (End) ======= -->
